module.exports = __webpack_public_path__ + "assets/images/template/project/photo-1-desktop.jpg?v=8b0a9a53";